import { EditLinkButton } from "Components/Shared/Buttons/EditLinkButton";
import { ResponsiveDialog } from "Components/Shared/Dialogs/ResponsiveDialog";
import { PublicInfoCard } from "Components/Social/PublicInfoCard";
import { EmailForm } from "Components/UserAccount/Shared/PublicInformation/EmailForm";
import type { PartyDto } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";
import { useState } from "react";

type Props = {
  party: PartyDto;
};

/** E-mail card of the public-information tab: party email with its own edit dialog. */
export const EmailCard = ({ party }: Props) => {
  const { t } = useResource();
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  return (
    <>
      <PublicInfoCard
        label={t(Resources.Common.Email)}
        value={party.email ?? null}
        action={
          <EditLinkButton
            onClick={() => setIsDialogOpen(true)}
            isDisabled={!party.publicID}
          />
        }
      />
      <ResponsiveDialog
        isOpen={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
        title={t(Resources.Common.Email)}
      >
        <EmailForm party={party} onSuccess={() => setIsDialogOpen(false)} />
      </ResponsiveDialog>
    </>
  );
};
